<template>
  <div id="app">
    <task-list></task-list>
  </div>
</template>

<script>
import TaskList from './components/TaskList.vue';

export default {
  components: {
    TaskList
  }
};
</script>

<style>
#app {
  text-align: center;
  margin-top: 60px;
}
</style>
